export const VIEW_TYPE = {
  day: 'dayView',
  week: 'weekView',
}
